<template>
  <th class="table-header-cell" v-if="show" :class="{ oldEmpty: isEmptyFilter}"
      @mouseover="mouseOver = true"  @mouseleave="mouseOver = false"
      @click.exact.stop.prevent="toggleSort"
      @click.ctrl.exact.stop.prevent="toggleMultisort"
  >
    <div class="order pull-right" v-if="sort">
        <i class="fa fa-fw"
           :class="showSort"
           aria-hidden="true">

        </i><sup v-if="sortNumber">{{ sortNumber }}</sup>
    </div>
    <span v-tooltip="{content: tooltip}"
        :class="{highlight: filterValue !== undefined && filterValue !== ''}">
        <slot :filter="filter" :table="vuetable"/>
    </span>
  </th>
</template>
<script>
export default {
  name: "DoctuTableHeaderCell",
  props: {
    tooltip: {
        default: '',
    },
    debounce: {
      default: false
    },
    sort: {},
    name: {},
    title: {},
  },
  data() {
    let val = this.filterValue;
    return {
      mouseOver: false,
      filter: {
        value: val
      },
    }
  },
  created() {
    this.filter.value = this.filterValue;
  },
  mounted() {
    let title = this.title || '';
    if (!title) {
      let slot = this.$slots.default;
      if (slot) {
        title = slot[0].text;
        if (!title) {
          if (slot[0].elm.tagName === 'I') {
            title = slot[0].elm.outerHTML;
          }
        }
      }
    }

    if (title) {
      this.$parent.$parent.pushField({
          name: this.name,
          sort: this.sort,
          title: title,
          tooltip: this.tooltip
      })
    }
  },
  watch: {
    'filter.value': function (value) {
      let payload = {};
      payload[this.name] = value;
      if(this.debounce){
        this.delayPayload(payload, this.$parent.$parent)
      }else{
        this.$parent.$parent.filterUpdate(payload);
      }
    },
    filterValue: function (value) {
      this.filter.value = value || '';
    }
  },
  computed: {
      showSort () {
          if (this.mouseOver){
              switch (this.sortDirection) {
                  case "NONE": return 'fa-sort-amount-desc grey';
                  case "ASC": return 'fa-sort-amount-asc grey';
                  case "DESC": return 'fa-sort-amount-desc grey';
              }
          }
          switch (this.sortDirection) {
              case "ASC": return 'fa-sort-amount-desc';
              case "DESC": return 'fa-sort-amount-asc';
          }
      },
      isEmptyFilter () {
          return this.filter.value === '' || typeof this.filter.value === 'undefined';
      },
    show: function () {
      return (this.hidden.indexOf(this.name) < 0);
    },

    hidden: function () {
      return this.$parent.hidden
    },

    sorts: function () {
      return this.$parent.sort || [];
    },

    filters: function () {
      return this.$parent.filter
    },
    sortNumber:  function () {
      if (this.sorts.length < 2) {
        return false;
      }

      return 1+ this.sorts.findIndex((e) => {
        if (e[this.sort]) {
          return e;
        }
      });
    },
    sortDirection: function () {
      let elt = this.sorts.find((e) => {
        if (e[this.sort]) {
          return e;
        }
      });
      if (elt) {
        return elt[this.sort];
      }
      return 'NONE';
    },

    vuetable: function () {
      return this.$parent.$parent;
    },

    filterValue: function () {
      return this.filters[this.name];
    },
  },

  methods: {
    delayPayload: _.debounce((payload, objParent)=> {objParent.filterUpdate(payload)}, 900),
    toggleSort: function () {
      if (this.sort) {
        this.$parent.$parent.sortUpdate({name: this.sort});
      }
    },
    toggleMultisort: function () {
      if (this.sort) {
        this.$parent.$parent.sortUpdateMulti({name: this.sort});
      }
    },
  }
}
</script>
<style>
.table-header-cell {
    position: relative;
}
.table-header-cell .highlight input, .table-header-cell .highlight select {
    background-color: #fffd03 !important;
}
.order {
    position: absolute;
    right: 0px;
}
.grey {
    color: #808080bd;
}
</style>
